// Copyright 2005-2011 David Caldwell <david@greenfelt.net>, Jim Radford <jim@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_order_by=piles.in_order_by,
                              in_suit_order=piles.in_suit_order, score_order_by=piles.score_order_by,
                              up=piles.up, king=piles.king;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var lib = require('./lib'), map=lib.map, add=lib.add;

solitaire.scorpion = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = 1;
        this.stock = new this.stock_pile("stock", this);
        this.tableau = [];
        for (var i=1; i<=7; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        this.ui.deck_play =
        this.stock.onclick = function() {
            if (!this.stock.pile.length) return;
            this.push_state();
            this.moves.push("*"+this.stock.move_char());
            for (var i=0; i<this.tableau.length; i++)
                if (this.stock.pile.length) {
                    this.stock.top().face = up;
                    this.animate_move(this.do_move([{ from:this.stock, to:this.tableau[i], fstart:this.stock.top_index(), n:1, internal:true }]));
                }
            this.end_of_move();
        }.bind(this);

        this.fix_replay_move = function(moves) {
            return moves.replace(/^010203/, "*0"); // Individual cards of a deal to one click of the deck.
        };
    }
    tableau_pile = class extends pile {
        accept_stacks = true;
        accept(cards) { return  (this.pile.length == 0 && cards[0].rank == king              ? 1 : 0)
                             || (this.pile.length      && in_suit_order(cards[0],this.top()) ? 3 : 0); }
        can_drag(index) { return this.pile[index].face == up; }
        splice = pile.prototype.splice_and_turn_over;
        xoffset = 0;
        maxstack = Math.ceil(19.7130699088146); // Determined by query in upgrades/maxstack.sql
    };

    stock_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return false; }
        xoffset = 5/90;
        yoffset = 0;
        maxstack = 3;
    };

    deal(deck) {
            this.stock.pile = deck;
            for (var n=0; n<7; n++) {
                for (var c=0; c<7; c++) {
                    this.tableau[c].push(this.stock.pop());
                    if (n >= 3 || c >= 4)
                        this.tableau[c].top().face = up;
                }
            }
    }

    is_complete() {
            for (var i in this.tableau) {
                if (this.tableau[i].pile.length != 0 &&
                    (this.tableau[i].pile.length != 13 || !in_order_by(in_suit_order, this.tableau[i].pile)))
                    return NOT_COMPLETE;
            }
            return WON;
    }

    score() {
            return add(map(function(p) { return score_order_by(in_suit_order, p.pile) }, this.tableau))
    }

    layout = grid(["stock"],
                  ["tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7"]);
}

module.exports = solitaire.scorpion;
// Copyright 2005-2011 David Caldwell <david@greenfelt.net>, Jim Radford <jim@greenfelt.net> All rights reserved.

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, in_order_by=piles.in_order_by,
                              in_suit_order=piles.in_suit_order, score_order_by=piles.score_order_by,
                              up=piles.up, king=piles.king;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), WON=seed_game.WON, NOT_COMPLETE=seed_game.NOT_COMPLETE;
var lib = require('./lib'), map=lib.map, add=lib.add;

solitaire.scorpion = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.decks = 1;
        this.stock = new this.stock_pile("stock", this);
        this.tableau = [];
        for (var i=1; i<=7; i++)
            this.tableau.push(new this.tableau_pile("tableau"+i, this));

        this.ui.deck_play =
        this.stock.onclick = function() {
            if (!this.stock.pile.length) return;
            this.push_state();
            this.moves.push("*"+this.stock.move_char());
            for (var i=0; i<this.tableau.length; i++)
                if (this.stock.pile.length) {
                    this.stock.top().face = up;
                    this.animate_move(this.do_move([{ from:this.stock, to:this.tableau[i], fstart:this.stock.top_index(), n:1, internal:true }]));
                }
            this.end_of_move();
        }.bind(this);

        this.fix_replay_move = function(moves) {
            return moves.replace(/^010203/, "*0"); // Individual cards of a deal to one click of the deck.
        };
    }
    tableau_pile = class extends pile {
        accept_stacks = true;
        accept(cards) { return  (this.pile.length == 0 && cards[0].rank == king              ? 1 : 0)
                             || (this.pile.length      && in_suit_order(cards[0],this.top()) ? 3 : 0); }
        can_drag(index) { return this.pile[index].face == up; }
        splice = pile.prototype.splice_and_turn_over;
        xoffset = 0;
        maxstack = Math.ceil(19.7130699088146); // Determined by query in upgrades/maxstack.sql
    };

    stock_pile = class extends pile {
        accept(card) { return false; }
        can_drag(index) { return false; }
        xoffset = 5/90;
        yoffset = 0;
        maxstack = 3;
    };

    deal(deck) {
            this.stock.pile = deck;
            for (var n=0; n<7; n++) {
                for (var c=0; c<7; c++) {
                    this.tableau[c].push(this.stock.pop());
                    if (n >= 3 || c >= 4)
                        this.tableau[c].top().face = up;
                }
            }
    }

    is_complete() {
            for (var i in this.tableau) {
                if (this.tableau[i].pile.length != 0 &&
                    (this.tableau[i].pile.length != 13 || !in_order_by(in_suit_order, this.tableau[i].pile)))
                    return NOT_COMPLETE;
            }
            return WON;
    }

    score() {
            return add(map(function(p) { return score_order_by(in_suit_order, p.pile) }, this.tableau))
    }

    layout = grid(["stock"],
                  ["tableau1", "tableau2", "tableau3", "tableau4", "tableau5", "tableau6", "tableau7"]);
}

module.exports = solitaire.scorpion;
